module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ph-374bb0d60bc777e60d0fd5350e9a03cc.svg";